export default __webpack_public_path__ + "static/TimesNow-SemiLight-5e3253e9d32d61fc761ca026f8899673.woff2";